function CorsiCard({city, days, place, mapLink}){

    return (
         <div className="corsi-card">
            <div className="flex justify-center">
                <i className="fas fa-location-dot corsi-card-icon"></i>

            </div>
            <h3 className="base-title text-center">{city}</h3>
            {/* <p className="corsi-card-text text-center">{days}</p> */}
            <p className="corsi-card-text text-center">{place}</p>

            <iframe 
                title="link"
                className="corsi-card-iframe"
                src={mapLink}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>
    );
}

export default CorsiCard